
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/doubts-and-solutions",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/doubts-and-solutions.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/doubts-and-solutions"])
      });
    }
  